import bidRowAmount from './bidRowAmount';
import bidUnit from './bidUnit';
import headerText from './headerText';
import projectBidData from './projectBidData';
import { Project } from '~/types/project';

export default function (project: Project, projectCosts: any, projectState: any) {
  return {
    headerText: headerText(project, projectState),
    bidRowAmount: bidRowAmount(project),
    bidUnit: bidUnit(project),
    projectBidData: projectBidData(project, projectCosts)
  };
}